import { getTermValue } from '@/packages/JsonQuery';
import { ESuburbanOfferFilter } from '@/packages/api-models/common/json_query';

import { type ITagGroupConfig } from '../types';

export const possessor: ITagGroupConfig = {
  get({ jsonQuery }) {
    const value = getTermValue('suburban_offer_filter')(jsonQuery);
    if (value == null) {
      return null;
    }

    return [
      {
        group: 'possessor',
        text: value === ESuburbanOfferFilter.Builder ? 'От застройщика' : 'От собственников и агентов',
      },
    ];
  },
  delete({ onChange }) {
    onChange({
      action: 'setPossessor',
      arguments: [null],
    });
  },
};
